module.exports = [{
      plugin: require('../plugins/wirehead-photo-source-plugin/gatsby-browser.js'),
      options: {"plugins":[],"appKeyId":"000fdd11dd5ec520000000007","appKey":"K000ywJ4Fx4I/krnAAqyi15SNaFgzWY","bucketPrefix":"/b2/"},
    },{
      plugin: require('../node_modules/gatsby-plugin-mdx/gatsby-browser.js'),
      options: {"plugins":[],"extensions":[".mdx",".md"],"gatsbyRemarkPlugins":[{"resolve":"gatsby-remark-images"},{"resolve":"gatsby-remark-smartypants"}],"defaultLayouts":{},"lessBabel":false,"remarkPlugins":[],"rehypePlugins":[],"mediaTypes":["text/markdown","text/x-markdown"],"root":"/app"},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Wireheadarts","short_name":"wireheadarts","start_url":"/","background_color":"#476284","theme_color":"#663399","display":"minimal-ui","icon":"src/images/w-icon.svg","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"40d4d454f333b02406691842ccd698c3"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
